import React from "react";

import { AppsSearch, AppsSearchInput, WholeWrapper } from "./components";
import CategoryApps from "../../components/category-apps/CategoryApps";
import PageOutline from "../../components/page-outline/PageOutline";
import ICONS from "../../constants/icons";
import { useAppCategory } from "../../hooks";

const Store = () => {
  const { categories } = useAppCategory();
  return (
    <PageOutline header={{ title: "Gary's Store" }}>
      <WholeWrapper>
        <AppsSearch>
          <ICONS.Search />
          <AppsSearchInput placeholder="Search for apps..." />
        </AppsSearch>
        {categories?.map((categ) => (
          <CategoryApps key={categ?.id} category={categ} />
        ))}
      </WholeWrapper>
    </PageOutline>
  );
};

export default Store;
